import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const get = async (get_url, params) => {
	const url = `${API_URL}${get_url}`;

	try {
		const response = await axios.get(url, {
			params,
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const post = async (post_url, form) => {
	const url = `${API_URL}${post_url}`;

	try {
		const response = await axios.post(url, form, {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const getExcel = async (get_url, params) => {
	const url = `${API_URL}${get_url}`;

	try {
		const response = await axios.get(url, {
			params,
			headers: {
				Authorization: localStorage.getItem("token"),
			},
			responseType: "blob",
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

export default {
	get,
	post,
	getExcel,
};
